import { Component, Input, OnChanges, SimpleChanges } from "@angular/core";
import { FormArray, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { GlobalFunction } from "../../../routes/services/globalFuntion";
import { MaintenanceAlertService } from "./services/maintenance_alert.service";
import { MaintenanceConfigRegion } from "./interfaces/maintenance_alert.interfaces";

@Component({
  selector: "app-config-maintenance-alert",
  templateUrl: "./maintenance_alert.html",
  styleUrls: ["./maintenance_alert.scss"]
})
export class ConfigMaintenanceAlertComponent implements OnChanges {
  @Input() id: null | number = null;

  firstHalfIndexes: number[] = Array.from({ length: 14 }, (item, index) => index);
  secondHalfIndexes: number[] = Array.from({ length: 14 }, (item, index) => index + 14);

  configForm: FormGroup;
  configuration: MaintenanceConfigRegion | null = null;
  loading_petition: boolean = false;

  constructor(
    private fb: FormBuilder,
    public maintenanceAlertService: MaintenanceAlertService,
    public globalFunction: GlobalFunction
  ) {
    this.configForm = this.fb.group({
      days: this.fb.array(
        Array.from({ length: 28 }, () => this.fb.control("", Validators.required))
      )
    });
  }

  /**
   * Recarga la configuración de la región cuando cambia el `id` recibido.
   * @param changes Cambios detectados en los `@Input` del componente.
   */
  ngOnChanges(changes: SimpleChanges): void {
    if (changes["id"] && this.id) {
      this.getConfig();
    }
  }

  get daysArray(): FormArray {
    return this.configForm.get("days") as FormArray;
  }

  /**
   * Obtiene la configuración de alerta de mantenimiento asociada a la región actual.
   */
  getConfig(): void {
    if (!this.id) {
      return;
    }
    const query = this.globalFunction.constructQuery({ region: this.id });
    this.maintenanceAlertService.list(query).subscribe((resp: any) => {
      const results = Array.isArray(resp) ? resp : resp && resp.results ? resp.results : [];
      const result = results.find((item: MaintenanceConfigRegion) => item.region === this.id) ?? null;

      this.configuration = result;
      this.daysArray.reset();
      if (result) {
        this.daysArray.patchValue(result.days);
      }
    });
  }

  /**
   * Guarda o actualiza la configuración de alerta de mantenimiento de la región.
   */
  setConfig(): void {
    if (!this.id) {
      return;
    }
    this.loading_petition = true;
    const body: Partial<MaintenanceConfigRegion> = {
      days: this.daysArray.value,
      region: this.id
    };

    const request = this.configuration
      ? this.maintenanceAlertService.update(this.configuration.id, body)
      : this.maintenanceAlertService.create(body);

    request.subscribe(
      (resp) => {
        this.configuration = resp;
        this.loading_petition = false;
        this.globalFunction.animation(
          "success",
          "¡Enhorabuena!",
          "Se guardo la configuración correctamente"
        );
      },
      () => {
        this.loading_petition = false;
      }
    );
  }
}
